# Tracking Form YAML editor — form authoring lives under /tracking/forms.
# Route: /tracking/forms/:id/edit  (create-mode via /tracking/forms/new/edit)

page-tracking-form-editor:
  type: Page
  archetype: edit
  meta:
    title: $t.tracking.forms.editor_title
    route: /tracking/forms/:id/edit
    layout: shell
    auth: required
  params:
    id:
      type: string
      required: true
  spatial:
    display: flex
    direction: column
    gap: $spacing.lg
    padding: $spacing.lg
    padding_inline: $spacing.xl
    overflow: auto
  tokens:
    background: $color_scheme.light.color.surface
  children:
    - form-editor-sm-notice
    - form-editor-content

form-editor-sm-notice:
  type: SmNotice
  content: $t.common.sm_notice_desktop

form-editor-content:
  type: Section
  spatial:
    display: flex
    direction: column
    gap: $spacing.lg
    responsive:
      sm:
        display: none
  children:
    - form-editor-header
    - form-editor-panel

form-editor-header:
  type: PageHeader
  content: $t.tracking.forms.editor_title
  # The editor is reachable from two parents: the form detail page (edit an
  # existing form) and the form list (create a new one, id="new"). A
  # single static back route can't serve both — "/tracking/forms/:id" 404s
  # for the create case (id="new"). back_history navigates via history.back() so
  # the user returns to whichever parent they came from; back_route is only the
  # cold-entry fallback (deep link / fresh tab) → the form list.
  back_history: true
  back_route: /tracking/forms

form-editor-panel:
  type: Widget
  ref: xp87-yaml-config-editor
  params:
    entity-type: forms
    entity-id: $params.id
    # xp87-yaml-config-editor's cancel-route defaults to /config/<entity-type>
    # (the convention every config-*-editor.cir.yaml page follows because its
    # route IS /config/<entity-type>/:id). This screen's route is
    # /tracking/forms/:id/edit, so the default would send Cancel to the
    # non-existent /config/forms route. Set explicitly to the real list route.
    cancel-route: /tracking/forms
  spatial:
    flex: 1
    min_height: 25rem
